<template>
  <v-row class="ma-0">
    <v-col cols="6">
      <v-card>
      <!-- <v-card-title class="pa-2">{{$t('message.document.copyDocuments')}} </v-card-title>
      <v-divider></v-divider> -->
      <v-card-text class="pa-1 px-4">
        <template v-if="loadingBase">
          <div class="subtitle-1 mt-1">{{ $t('message.hse.gettingFolders') }}</div>
          <v-progress-linear rounded height="6" indeterminate color="primary"></v-progress-linear>
        </template>
        <v-treeview v-else dense shaped hoverable class="tree--document" :style="{ 'minHeight': '40vh', 'maxHeight': '65vh', overflow: 'scroll' }"
          v-model="selectedNodesList" :load-children="getChildrenItems"
          :open.sync="open" return-object :items="foldersList"><!-- activatable :active.sync="active" :active.sync="active" activatable @update:active="getFilesForFolder" leaf independent-->
          <template v-slot:prepend="{ item, open }">
            <v-layout row wrap class="ma-0">
              <v-icon v-if="item.is_document" :color="item.color">
                {{ item.icon }}
              </v-icon>
              <v-icon v-else color="#ffda6b">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
              <v-checkbox v-if="item.is_document" dense :value="item.documentValue" v-model="documentsSelected" hide-details class="pa-0 ma-0 my-auto"></v-checkbox><!-- v-if="item.is_document" -->
            </v-layout>
          </template>
          <template v-slot:label="{ item }">
            <v-hover v-slot:default="{ hover }">
              <div class="text-truncate">
                <v-icon v-if="hover" small @click.stop="navigateToOD(item.webUrl)">mdi-open-in-new</v-icon>
                {{ item.name }}
              </div>
            </v-hover>
          </template>
        </v-treeview>
        <v-alert color="info" dark icon="mdi-cloud" border="left" prominent outlined v-if="foldersList.length <= 0 && !loadingBase">
          {{ $t('message.hse.noFolders') }}
        </v-alert>
      </v-card-text>
      <!-- <v-divider></v-divider>
      <v-card-actions class="pa-1">
        <v-flex class="text-center">
          <v-btn color="primary" @click="copySelectedDocuments" class="ma-1" :loading="copyDocumentsLoader">{{$t('message.common.copy')}}</v-btn>
          <v-btn color="error" @click="$emit('closeDialog')" class="ma-1">{{$t('message.common.cancel')}}</v-btn>
        </v-flex>
      </v-card-actions> -->
    </v-card>
    </v-col>
    <v-col cols="6">
      <v-card>
        <v-card-title class="px-2 pa-1">{{$t('message.form.documents')}} </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1 px-4" :style="{ 'minHeight': '33vh', 'maxHeight': '65vh', overflow: 'scroll' }">
          <draggable v-if="documentsSelected && documentsSelected.length" v-model="documentsSelected" class="row mx-1" id="documents-select-draggable-section">
            <template class="" v-for="(document, index) in documentsSelected">
              <v-card class="pa-1 my-1" outlined :key="document.id" width="100%" tile>
                <v-layout>
                  <v-icon color="info" style="cursor: move;" class="mr-3">mdi-drag</v-icon>
                  <p class="mb-0">{{document.name}}</p>
                  <v-spacer></v-spacer>
                  <v-icon color="error" class="mx-2" @click="documentsSelected.splice(index, 1)">mdi-delete-circle</v-icon>
                </v-layout>
              </v-card>
            </template>
          </draggable>
          <v-alert prominent text v-else type="info" class="mt-2">
            <v-row align="center">
              <v-col class="grow">{{ $t('message.hse.noDocuments') }}</v-col>
            </v-row>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['documents', 'traverseNodes', 'rootFolder'],
  model: {
    prop: 'documents',
    event: 'change'
  },
  data () {
    return {
      MODULE_URL: 'sharepoint',
      open: ['public'],
      foldersList: [],
      loadingBase: false,
      documentsLoading: false,
      loading: false,
      selectedNodesList: [],
      childCount: 0,
      copyDocumentsLoader: false,
      allNodes: [],
      documentsSelected: this.documents,
      traverseTracker: {},
      traverseNodeIds: this.traverseNodes || {}
    }
  },
  computed: {
    ...mapGetters(['formType'])
  },
  created () {
    if (this.rootFolder) {
      const baseFolder = { id: this.rootFolder.id, name: this.rootFolder.text, children: [], isbasefolder: true }
      this.foldersList.push(baseFolder)
      this.allNodes = [this.$formatter.cloneVariable(baseFolder)]
      this.open.push(baseFolder)
    } else this.getBaseFolders()
  },
  components: {
    draggable: () => import('vuedraggable')
  },
  watch: {
    documentsSelected (val) {
      this.$emit('change', val)
    }
  },
  methods: {
    findPropFromObj (object, key) {
      // eslint-disable-next-line no-prototype-builtins
      if (object.hasOwnProperty(key)) {
        return object[key]
      }
      for (const k of Object.keys(object)) {
        if (typeof object[k] === 'object') {
          const o = this.findPropFromObj(object[k], key)
          if (o !== null && typeof o !== 'undefined') { return o }
        }
      }
      return null
    },
    setIdInParentId (model) {
      const parentObj = this.findPropFromObj(this.traverseTracker, model.parentId)
      if (parentObj) parentObj[model.id] = {}
      else this.traverseTracker[model.id] = {}
    },
    async loadChildren (traverseNodes) {
      for (const nodeId of Object.keys(traverseNodes)) {
        const parentObj = this.getFolderById(this.foldersList, nodeId)
        if (parentObj) {
          this.setIdInParentId(parentObj)
          const { data } = await this.$_executeApi('get', `${this.MODULE_URL}/get_subfolder_items/${nodeId}`)
          this.setChildren(data, parentObj)
        }
        if (traverseNodes[nodeId] !== null && typeof traverseNodes[nodeId] === 'object') this.loadChildren(traverseNodes[nodeId])
      }
    },
    getFolderById (folderList, nodeId) {
      folderList = folderList || []
      const nodeObj = folderList.find(x => (x && (x.id === nodeId)))
      if (nodeObj) return nodeObj
      const allchildrenOfCurrentLevel = folderList.map(x => (x && x.children)).flat().filter(x => x)
      const innerNodeObj = this.getFolderById(allchildrenOfCurrentLevel, nodeId)
      return innerNodeObj || []
    },
    setChildren (children, parentItem) {
      if (this.$formatter.isArrayHasData(children)) {
        for (let i = 0; i < children.length; i++) {
          const mimetypeObj = children[i].is_document ? this.$formatter.mimeTypeOfDocument(children[i].mimetype) : {}
          const childNode = {
            id: children[i].id,
            name: children[i].name,
            webUrl: children[i].weburl,
            children: children[i].childcount > 0 ? [] : undefined,
            is_document: children[i].is_document,
            childcount: children[i].childcount,
            parentId: parentItem.id,
            ...mimetypeObj
          }
          if (childNode.is_document) childNode.documentValue = { id: childNode.id, name: childNode.name }
          parentItem.children.push(childNode)
          this.open.push(parentItem)
        }
        this.allNodes = [...this.allNodes, ...this.$formatter.cloneVariable(parentItem.children)]
        this.childCount++
      }
    },
    getValue (item) {
      return { id: item.id, name: item.name }
    },
    getBaseFolders () {
      this.loadingBase = true
      this.foldersList = []
      this.listOfActiveFiles = []
      this.childCount = 0
      this.$_executeApi('get', `${this.MODULE_URL}/get_base_folder_and_fields`)
        .then((response) => {
          const folder = response.data.basefolder
          const baseFolder = { id: folder.id, name: folder.name, children: [], webUrl: folder.weburl, childcount: folder.childcount, isbasefolder: true }
          this.foldersList.push(baseFolder)
          this.allNodes = [this.$formatter.cloneVariable(baseFolder)]
        }).finally(async () => {
          this.loadChildren(this.traverseNodeIds).then(() => {
            this.loadingBase = false
          })
        })
    },
    getChildrenItems (item) {
      this.setIdInParentId(item)
      return this.$_executeApi('get', `${this.MODULE_URL}/get_subfolder_items/${item.id}`)
        .then((response) => {
          const children = response.data
          if (this.$formatter.isArrayHasData(children)) {
            for (let i = 0; i < children.length; i++) {
              const mimetypeObj = children[i].is_document ? this.$formatter.mimeTypeOfDocument(children[i].mimetype) : {}
              const childNode = {
                id: children[i].id,
                name: children[i].name,
                webUrl: children[i].weburl,
                children: children[i].childcount > 0 ? [] : undefined,
                is_document: children[i].is_document,
                childcount: children[i].childcount,
                parentId: item.id,
                ...mimetypeObj
              }
              if (childNode.is_document) childNode.documentValue = { id: childNode.id, name: childNode.name }
              item.children.push(childNode)
            }
            this.allNodes = [...this.allNodes, ...this.$formatter.cloneVariable(item.children)]
            this.childCount++
          }
        })
    },
    getSelectedNodeFiles (id) {
      this.documentsLoading = true
      this.$_executeApi('get', `${this.MODULE_URL}/get_children_documents/${id}`)
        .then((response) => {
          const files = (response && response.data) ? response.data : []
          this.listOfActiveFiles = files
        })
        .finally(() => {
          this.documentsLoading = false
        })
    },
    navigateToOD (url) {
      window.open(url, '_blank')
    },
    copySelectedDocuments () {
      const selectedNodes = this.$formatter.cloneVariable(this.selectedNodesList)
      let idsToExcludeFromCheck = []
      selectedNodes.forEach(node => {
        if (idsToExcludeFromCheck.includes(node.id)) return
        if (node.parentId) {
          const selectedChildren = selectedNodes.filter(x => x.parentId === node.parentId)
          const parentObj = this.allNodes.find(x => x.id === node.parentId)
          if (parentObj.childcount === selectedChildren.length) {
            const nodesToRemoveIds = selectedNodes.filter(x => x.parentId === node.parentId).map(y => y.id)
            idsToExcludeFromCheck = [...idsToExcludeFromCheck, ...nodesToRemoveIds]
          } else {
            idsToExcludeFromCheck = [...idsToExcludeFromCheck, node.parentId]
          }
        }
      })
      const newList = selectedNodes.filter(x => !idsToExcludeFromCheck.includes(x.id))
      // eslint-disable-next-line no-unused-expressions
      const modelList = newList.map(x => {
        return { id: x.id, isdocument: x.is_document }
      })
      this.$emit('copyDocuments', modelList)
    }
  }
}
</script>

<style>
.v-treeview-node > .v-treeview-node__root {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}
.v-treeview-node > .v-treeview-node__root {
  min-height: 28px !important;
}
.v-treeview-node__prepend .v-input--selection-controls__input {
  margin-right: 0 !important;
}
.tree--document .v-content .v-card.v-sheet.theme--light {
  background-color: #ffffff !important;
  border-left: 5px solid red !important
}
</style>
